import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-stock-ob-range',
  templateUrl: './stock-ob-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockOpeningBalanceRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
